import React, { useMemo } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import './DragAndDrop.scss';

const DragAndDrop = ({
  children,
  style = { display: 'flex', flexDirection: 'column', gap: '0.625rem' },
  callback = null,
  droppableId = 'droppable',
}) => {
  const items = useMemo(() => {
    return React.Children.toArray(children).map((child, idx) => ({
      id: String(child.key ?? `item-${idx}`),
      content: child,
    }));
  }, [children]);

  const handleDragAndDrop = result => {
    if (!result.destination) return;

    const startIndex = result.source.index;
    const endIndex = result.destination.index;

    if (startIndex === endIndex) return;
    if (callback) callback({ startIndex, endIndex });
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // не удалять isDragging, вероятно магия, но без него не работает))
    userSelect: 'none',
    ...draggableStyle,
  });

  const getListStyle = () => ({
    ...style,
  });

  return (
    <DragDropContext onDragEnd={handleDragAndDrop}>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
            {items.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                    {item.content}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragAndDrop;
